import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from "@shared/guards/auth.guard";
import {NoAuthGuard} from "@shared/guards/no-auth.guard";
import {SetCurrentUserGuard} from "@shared/guards/set-current-user.guard";
import {MaintenanceComponent} from "./maintenance/maintenance.component";
import {MaintenanceModeGuard} from "@shared/guards/maintenance-mode.guard";

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./modules/shop/shop.module').then(m => m.ShopModule),
        canActivate: [SetCurrentUserGuard, MaintenanceModeGuard],
    },
    {
        path: 'auth',
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
        canActivate: [NoAuthGuard, MaintenanceModeGuard],
    },
    {
        path: 'my-account',
        loadChildren: () => import('./modules/my-account/my-account.module').then(m => m.MyAccountModule),
        canActivate: [AuthGuard, MaintenanceModeGuard],
    },
    {
        path: 'maintenance',
        component: MaintenanceComponent,
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
